import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Subscription } from "types/Models/subscription";

interface OnboardingPlansState {
  taxOnboardingPlan: string;
  taxSubscription?: Subscription | null;
}
export const initialStateForOboardingPlans: OnboardingPlansState = {
  taxOnboardingPlan: "",
  taxSubscription: null,
};

export const onboardingPlans = createSlice({
  name: "onboardingPlans",
  initialState: initialStateForOboardingPlans,
  reducers: {
    setTaxOboardingValue: (
      state,
      action: PayloadAction<typeof initialStateForOboardingPlans>
    ) => {
      state.taxOnboardingPlan = action.payload.taxOnboardingPlan;
    },
  },
});

export const { setTaxOboardingValue } = onboardingPlans.actions;
export default onboardingPlans.reducer;
